export default __webpack_public_path__ + "media/music/d0d77f8531e38b67ddbdfba65ff9617d.mp3";